import { d as _objectSpread2 } from '../_helpers/_rollupPluginBabelHelpers.js';
import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.array.filter.js';
import 'core-js/modules/es.array.includes.js';
import 'core-js/modules/es.array.map.js';
import 'core-js/modules/es.array.sort.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.string.includes.js';
import { getRect, isMounted, getDocumentScrollTop, getDocumentScrollLeft, getWindowHeight } from '../global/dom.js';
import { MaxHeight, Dimension, MinWidth, Directions } from './popup.consts.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.object.entries.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.set.js';
import 'core-js/modules/es.string.split.js';
import 'core-js/modules/web.dom-collections.for-each.js';
import 'core-js/modules/web.dom-collections.iterator.js';

function getScrollingCoordinates(container) {
  if (container !== null) {
    return {
      top: container.scrollTop,
      left: container.scrollLeft
    };
  }
  return {
    top: getDocumentScrollTop(),
    left: getDocumentScrollLeft()
  };
}
function getPositionStyles(popup, anchorRect, anchorLeft, anchorTop, offset) {
  var popupWidth = popup.offsetWidth;
  var popupHeight = popup.offsetHeight;
  var anchorBottom = anchorTop + anchorRect.height;
  var anchorRight = anchorLeft + anchorRect.width;
  var popupLeft = anchorLeft - popupWidth;
  var popupTop = anchorTop - popupHeight;
  var popupRightToLeft = anchorRight - popupWidth;
  var popupHorizontalCenter = anchorLeft + anchorRect.width / 2 - popupWidth / 2;
  var popupVerticalCenter = anchorTop + anchorRect.height / 2 - popupHeight / 2;
  var popupBottomToTop = anchorBottom - popupHeight;
  return {
    [Directions.BOTTOM_RIGHT]: {
      left: anchorLeft,
      top: anchorBottom + offset
    },
    [Directions.BOTTOM_LEFT]: {
      left: popupRightToLeft,
      top: anchorBottom + offset
    },
    [Directions.BOTTOM_CENTER]: {
      left: popupHorizontalCenter,
      top: anchorBottom + offset
    },
    [Directions.TOP_RIGHT]: {
      left: anchorLeft,
      top: popupTop - offset
    },
    [Directions.TOP_LEFT]: {
      left: popupRightToLeft,
      top: popupTop - offset
    },
    [Directions.TOP_CENTER]: {
      left: popupHorizontalCenter,
      top: popupTop - offset
    },
    [Directions.LEFT_BOTTOM]: {
      left: popupLeft - offset,
      top: anchorTop
    },
    [Directions.LEFT_TOP]: {
      left: popupLeft - offset,
      top: popupBottomToTop
    },
    [Directions.LEFT_CENTER]: {
      left: popupLeft - offset,
      top: popupVerticalCenter
    },
    [Directions.RIGHT_BOTTOM]: {
      left: anchorRight + offset,
      top: anchorTop
    },
    [Directions.RIGHT_TOP]: {
      left: anchorRight + offset,
      top: popupBottomToTop
    },
    [Directions.RIGHT_CENTER]: {
      left: anchorRight + offset,
      top: popupVerticalCenter
    }
  };
}
function verticalOverflow(styles, scrollingCoordinates, attrs) {
  var containerHeight = attrs.container !== null ? attrs.container.clientHeight : getWindowHeight();
  var viewportMinX = scrollingCoordinates.top + attrs.sidePadding;
  var viewportMaxX = scrollingCoordinates.top + containerHeight - attrs.sidePadding;
  var topOverflow = Math.max(viewportMinX - styles.top, 0);
  var popupHeight = attrs.popup.clientHeight;
  var verticalDiff = styles.top + popupHeight - viewportMaxX;
  var bottomOverflow = Math.max(verticalDiff, 0);
  return topOverflow + bottomOverflow;
}
function horizontalOverflow(styles, scrollingCoordinates, attrs) {
  var containerWidth = attrs.container !== null ? attrs.container.clientWidth : window.innerWidth;
  var viewportMinY = scrollingCoordinates.left + attrs.sidePadding;
  var viewportMaxY = scrollingCoordinates.left + containerWidth - attrs.sidePadding;
  var leftOverflow = Math.max(viewportMinY - styles.left, 0);
  var popupWidth = attrs.popup.clientWidth;
  var horizontalDiff = styles.left + popupWidth - viewportMaxY;
  var rightOverflow = Math.max(horizontalDiff, 0);
  return leftOverflow + rightOverflow;
}
var positionPropKeys = ['directions', 'autoPositioning', 'autoCorrectTopOverflow', 'sidePadding', 'top', 'left', 'offset', 'maxHeight', 'minWidth'];
var defaultcontainerRect = {
  top: 0,
  left: 0
};
function handleTopOffScreen(_ref) {
  var sidePadding = _ref.sidePadding,
    styles = _ref.styles,
    anchorRect = _ref.anchorRect,
    maxHeight = _ref.maxHeight,
    popupScrollHeight = _ref.popupScrollHeight,
    direction = _ref.direction,
    scroll = _ref.scroll;
  var BORDER_COMPENSATION = 1;
  var TOP_LEFT = Directions.TOP_LEFT,
    TOP_RIGHT = Directions.TOP_RIGHT,
    TOP_CENTER = Directions.TOP_CENTER,
    RIGHT_TOP = Directions.RIGHT_TOP,
    LEFT_TOP = Directions.LEFT_TOP;
  var openedToTop = direction != null && [TOP_LEFT, TOP_RIGHT, TOP_CENTER, RIGHT_TOP, LEFT_TOP].includes(direction);
  if (!openedToTop) {
    return styles;
  }
  var isAttachedToAnchorTop = direction != null && [TOP_LEFT, TOP_CENTER, TOP_RIGHT].includes(direction);
  var attachingPointY = isAttachedToAnchorTop ? anchorRect.top : anchorRect.bottom;
  var effectiveHeight = maxHeight && typeof maxHeight === 'number' ? Math.min(popupScrollHeight, maxHeight) : popupScrollHeight;
  var hypotheticalTop = attachingPointY - effectiveHeight;
  if (hypotheticalTop <= sidePadding) {
    styles.top = sidePadding + scroll.top;
    styles.maxHeight = attachingPointY - sidePadding + BORDER_COMPENSATION;
  }
  return styles;
}
function maxHeightForDirection(direction, anchorNode, containerNode) {
  var container = containerNode || document.documentElement;
  var domRect = anchorNode.getBoundingClientRect();
  var containerRect = container.getBoundingClientRect();
  var containerTop = domRect.top < 0 ? containerRect.top : Math.max(containerRect.top, 0);
  var topMaxHeight = Math.max(domRect.top - containerTop, 0);
  var containerHeight = Math.max(containerRect.height,
  // XXX
  // If container is the document element
  // then we check client height too because we may have situation when
  // "height" from "getBoundingClientRect" less then "clientHeight".
  container === document.documentElement ? container.clientHeight : 0);
  var bottomMaxHeight = Math.max(containerHeight - (topMaxHeight + domRect.height), 0);
  switch (direction) {
    case Directions.TOP_LEFT:
    case Directions.TOP_CENTER:
    case Directions.TOP_RIGHT:
      return topMaxHeight;
    case Directions.BOTTOM_LEFT:
    case Directions.BOTTOM_CENTER:
    case Directions.BOTTOM_RIGHT:
      return bottomMaxHeight;
    case Directions.LEFT_BOTTOM:
    case Directions.RIGHT_BOTTOM:
      return domRect.height + bottomMaxHeight;
    case Directions.LEFT_TOP:
    case Directions.RIGHT_TOP:
      return domRect.height + topMaxHeight;
    case Directions.RIGHT_CENTER:
    case Directions.LEFT_CENTER:
      return domRect.height / 2 + Math.min(bottomMaxHeight / 2, topMaxHeight / 2);
    default:
      return null;
  }
}
function position(attrs) {
  var popup = attrs.popup,
    anchor = attrs.anchor,
    container = attrs.container,
    directions = attrs.directions,
    autoPositioning = attrs.autoPositioning,
    sidePadding = attrs.sidePadding,
    top = attrs.top,
    left = attrs.left,
    offset = attrs.offset,
    maxHeight = attrs.maxHeight,
    minWidth = attrs.minWidth,
    _attrs$autoCorrectTop = attrs.autoCorrectTopOverflow,
    autoCorrectTopOverflow = _attrs$autoCorrectTop === void 0 ? true : _attrs$autoCorrectTop;
  var styles = {
    top: 0,
    left: 0
  };
  var chosenDirection = null;
  var containerRect = container !== null ? getRect(container) : defaultcontainerRect;
  var defaultAnchor = container !== null ? container : document.body;
  var anchorRect = getRect(isMounted(anchor) ? anchor : defaultAnchor);
  var scroll = getScrollingCoordinates(container);
  var anchorLeft = anchorRect.left + scroll.left + left - containerRect.left;
  var anchorTop = anchorRect.top + scroll.top + top - containerRect.top;
  if (popup) {
    var overflowAttrs = _objectSpread2(_objectSpread2({}, attrs), {}, {
      popup
    });
    var directionsMatrix = getPositionStyles(popup, anchorRect, anchorLeft, anchorTop, offset);
    if (!autoPositioning || directions.length === 1) {
      styles = directionsMatrix[directions[0]];
      chosenDirection = directions[0];
    } else {
      var sortedByIncreasingOverflow = directions.
      // Fall back to the first option
      concat(directions[0]).filter(function (direction) {
        return directionsMatrix[direction];
      }).map(function (direction) {
        return {
          styles: directionsMatrix[direction],
          direction
        };
      }).sort(function (_ref2, _ref3) {
        var stylesA = _ref2.styles;
        var stylesB = _ref3.styles;
        var overflowA = verticalOverflow(stylesA, scroll, overflowAttrs) + horizontalOverflow(stylesA, scroll, overflowAttrs);
        var overflowB = verticalOverflow(stylesB, scroll, overflowAttrs) + horizontalOverflow(stylesB, scroll, overflowAttrs);
        return overflowA - overflowB;
      });
      styles = sortedByIncreasingOverflow[0].styles;
      chosenDirection = sortedByIncreasingOverflow[0].direction;
    }
    // because of the anchor negative margin top and left also may become negative
    ['left', 'top'].forEach(function (key) {
      if (styles[key] < 0) {
        styles[key] = 0;
      }
    });
  }
  if (maxHeight === MaxHeight.SCREEN || maxHeight === 'screen') {
    // this feature works properly only when direction is BOTTOM_* or *_BOTTOM
    styles.maxHeight = window.innerHeight + scroll.top - styles.top - Dimension.MARGIN;
  } else if (maxHeight) {
    styles.maxHeight = maxHeight;
  }
  if (autoCorrectTopOverflow) {
    var _popup$scrollHeight;
    styles = handleTopOffScreen({
      sidePadding,
      styles,
      anchorRect,
      maxHeight,
      direction: chosenDirection,
      popupScrollHeight: (_popup$scrollHeight = popup === null || popup === void 0 ? void 0 : popup.scrollHeight) !== null && _popup$scrollHeight !== void 0 ? _popup$scrollHeight : 0,
      scroll
    });
  }
  if (minWidth === MinWidth.TARGET || minWidth === 'target') {
    styles.minWidth = anchorRect.width;
  } else if (minWidth) {
    styles.minWidth = anchorRect.width < minWidth ? minWidth : anchorRect.width;
  }
  return {
    styles,
    direction: chosenDirection
  };
}

export { Dimension, Directions, MaxHeight, MinWidth, position as default, maxHeightForDirection, positionPropKeys };
